// extracted by mini-css-extract-plugin
export default {"chatPageContainer":"ChatPageContainer_chatPageContainer__RdHKP"};